var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChartGenerator',{ref:"canvas",attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"plugins":_vm.plugins,"css-classes":"chartLine","styles":_vm.styles,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }